let debounceTimer;

const debounce = ( cb, delay ) => {
    clearTimeout( debounceTimer );
    debounceTimer = setTimeout( cb, delay );
}
